import { CommonModule, HashLocationStrategy, LocationStrategy, registerLocaleData } from "@angular/common";
import { HttpClientModule, HTTP_INTERCEPTORS } from "@angular/common/http";
import { LOCALE_ID, NgModule } from "@angular/core";
import { MatIconModule } from "@angular/material/icon";
import { MatDialogModule } from "@angular/material/dialog";
import { BrowserModule } from "@angular/platform-browser";
import "hammerjs";
import { BlockUIModule } from "ng-block-ui";
import { RecaptchaModule, RecaptchaSettings, RECAPTCHA_SETTINGS } from "ng-recaptcha";
import { NgxHmCarouselModule } from "ngx-hm-carousel";
import { NgxMaskModule } from "ngx-mask";
import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { AuthGuard } from "./auth/_guards";
import { AuthInterceptor } from "./auth/_guards/auth.interceptor";
import { AuthModule } from "./auth/_guards/auth.module";
import { IdentityStorage } from "./auth/_models/identity.storage";
import { AuthenticationService } from "./auth/_services";
import { MaterialModule } from "./material.module";

import { PadraoService } from "./service/padrao/padrao.service";
import { UserService } from "./service/user/user.service";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";

import { ToastrModule } from "ngx-toastr";
import { NZ_I18N } from "ng-zorro-antd/i18n";
import { en_US } from "ng-zorro-antd/i18n";
import en from "@angular/common/locales/en";
import localePt from "@angular/common/locales/pt";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { AntdModule } from "./antd.module";

import { IconsProviderModule } from "./icons-provider.module";
import { InputMaskModule } from "@ngneat/input-mask";
import { LoadingInterceptor } from "./core/interceptors/loading/loading.interceptor";
import { SharedModule } from "./shared/shared.module";
import { MAT_DATE_FORMATS, MatNativeDateModule } from "@angular/material/core";
import { MY_DATE_FORMATS } from "./shared/utils/date-formats-util";
import { CertificadoService } from "./service/certificado/certificados.service";
import { UsuarioService } from "./service/usuario/usuario.service";
import { CarouselModule } from "ngx-owl-carousel-o";
import { CarrosselService } from "./service/carrossel/carrossel.service";
import { EstudanteService } from "./service/estudante/estudante.service";
import { RecuperarSenhaModule } from "./modules/recuperar-senha/recuperar-senha.module";
import { RedefinirSenhaModule } from "./modules/redefinir-senha/redefinir-senha.module";
import { AlterarSenhaModule } from "./modules/alterar-senha/alterar-senha.module";
import { EstudanteComponent } from "./pages/cadastro/estudante/estudante.component";
import { ComplementoEstudanteComponent } from "./pages/cadastro/complemento-estudante/complemento-estudante.component";
import { PipeModule } from "./pipes/pipe.module";
import { CertificadoPdfService } from "./service/certificado/certificado-pdf.service";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { ParametroSessaoService } from "./service/parametro-sessao/parametro-sessao.service";
import { MatCardModule } from "@angular/material/card";
import { NzButtonModule } from "ng-zorro-antd/button";

registerLocaleData(localePt);

const globalSettings: RecaptchaSettings = {
    siteKey: "6Lc8vGwUAAAAAOsheXbsSd7qKpwLv0t2ECF1i___",
};

@NgModule({
    declarations: [AppComponent, EstudanteComponent, ComplementoEstudanteComponent],
    imports: [
        MatDialogModule,
        MatIconModule,
        BrowserModule,
        MaterialModule,
        AntdModule,
        CommonModule,
        RecuperarSenhaModule,
        RedefinirSenhaModule,
        AlterarSenhaModule,
        AppRoutingModule,
        HttpClientModule,
        NgxMaskModule.forRoot(),
        BlockUIModule,
        BlockUIModule.forRoot(),
        AuthModule,
        NgxHmCarouselModule,
        RecaptchaModule,
        BrowserAnimationsModule,
        ToastrModule.forRoot(),
        FormsModule,
        ReactiveFormsModule,
        IconsProviderModule,
        InputMaskModule,
        SharedModule,
        CarouselModule,
        PipeModule,
        MatDatepickerModule,
        MatFormFieldModule,
        MatInputModule,
        MatNativeDateModule,
        MatCardModule,
        NzButtonModule,
    ],
    providers: [
        PadraoService,
        IdentityStorage,
        AuthGuard,
        AuthenticationService,
        UserService,
        { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: LoadingInterceptor, multi: true },
        { provide: LocationStrategy, useClass: HashLocationStrategy },
        { provide: RECAPTCHA_SETTINGS, useValue: globalSettings },
        { provide: NZ_I18N, useValue: en_US },
        { provide: LOCALE_ID, useValue: "pt-BR" },
        { provide: MAT_DATE_FORMATS, useValue: MY_DATE_FORMATS },
        CertificadoService,
        EstudanteService,
        CarrosselService,
        CertificadoPdfService,
        ParametroSessaoService,
    ],
    entryComponents: [],
    bootstrap: [AppComponent],
})
export class AppModule {}
